import { AppViewStates } from "./enum/app-view-states";
import { Injectable, signal, Signal } from "@angular/core";
import { SnippetSearchResultItem } from "./types/snippetSearchResultItem";
import { MessagesItem } from "src/services/messages.service";
import { copypastePaletteItem } from "./types/copypastePaletteItem";
import * as ace from "ace-builds";
import { ItemStates } from "./enum/item-states";
import { SnippetsGroupsItem } from "./types/snippets-groups-item";
import { TaskTrackerItem } from "./types/task-tracker/task-tracker-item";
import { copypasteTempPaletteItem } from "./types/copypasteTempPaletteItem";


@Injectable({
  providedIn: 'root'
})
/** модель основная общая */
export class Model {
  /** авторизован */
  auth = signal<boolean|undefined>(undefined);
  helpVisible = signal<boolean>(false);

  /** основное состояние приложения */
  mainViewState = signal<AppViewStates>(AppViewStates.code);

  /** производится сохранение на сервер */
  saving = signal<boolean>(false);

  patternsArrayTextareaVal = signal<string>('');
  patterns = signal<string[]>([]);
  copypasteTempPalette = signal<copypasteTempPaletteItem[]>([]);

  /**сообщения */
  messages = signal<MessagesItem[]>([]);

  isOfflineOnly: boolean = true;
  
  ///////в разработке

  /**админские права */
  get isAdmin(): boolean { return false; }
  userName: string = '';

  copypastePalette: copypastePaletteItem[] = [];

  /**данные создания/редактирования сниппета */
  snippetEditItem = {
    value: '',
    description: '',
    id: 0,
    mode: 'sqlserver'
  }

  /**состояние создания/редактирования сниппета */
  snippetState: ItemStates = ItemStates.None;
  snippetsGroups: SnippetsGroupsItem[] = [];
  snippetGroupVal: string = '0';
  snippetSearchVal: string = '';
  snippetSearchResult: SnippetSearchResultItem[] = [];

  /**js скрипт */
  replacingScriptText: string = '';
  replacingScriptAceEditor?: ace.Ace.Editor;

  loginResultMessage: string = '';

  /**задача (трэкер) */
  taskItem: TaskTrackerItem = new TaskTrackerItem();
  traskItemNoteId: number = 0;
  trackerItemMainTextInnerHtml: string = '';

  ////методы

  /** проверка состояния приложения
   * @param state проверяемое состояние */
  isInAppViewState(state: AppViewStates): boolean {
    return state === this.mainViewState();
  }
}
